import { render, staticRenderFns } from "./pwa_export.vue?vue&type=template&id=c2793a60&scoped=true&"
import script from "./pwa_export.vue?vue&type=script&lang=js&"
export * from "./pwa_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2793a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2793a60')) {
      api.createRecord('c2793a60', component.options)
    } else {
      api.reload('c2793a60', component.options)
    }
    module.hot.accept("./pwa_export.vue?vue&type=template&id=c2793a60&scoped=true&", function () {
      api.rerender('c2793a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/pwa_export.vue"
export default component.exports